/**
 * Shared layout component for error pages (404, 500, global error).
 * Provides consistent styling and structure across all error pages.
 */

interface ErrorPageLayoutProps {
  title: string;
  message: string;
  action: React.ReactNode;
}

export function ErrorPageLayout({ title, message, action }: ErrorPageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <h1 className="mb-4 text-2xl font-bold">{title}</h1>
      <p className="mb-4 text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}
